import { useMutation, useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { ApiError } from '../../api/client'
import { adamAssignQuery, assignCompanyActions } from '../../api/settingsEaseedeskAdamIntop'
import { toast } from '../../ui/notify'
import { LoadFailed } from '../../ui/LoadFailed'
import { Spinner } from '../../ui/Spinner'
import { Forbidden } from './AdamIntopSettingsPage'

/**
 * Settings → Easeedesk → Adam Intop → Assign Company Actions.
 *
 * Perechea lui `version-3/easeedesk_settings/adam_intop/assign_company_actions.php`:
 * se alege o firma, si toate actiunile furnizorului o primesc in lista lor de
 * firme (`run_only_on_companies`).
 *
 * Firma trebuie sa fie a furnizorului. Pe calea veche id-ul venea din cerere
 * si intra in interogare fara sa se uite cineva al cui e.
 *
 * Dreptul e al ecranului, ca in portal:
 * `settings.adam_intop_assign_company_actions.read`.
 */
export function AdamIntopAssignCompanyPage() {
  const shell = useQuery(adamAssignQuery())
  const [company, setCompany] = useState('')

  const assign = useMutation({
    mutationFn: () => assignCompanyActions(Number(company)),
    onSuccess: (result) => toast(result.message ?? 'Assigned Successfully', 'Success'),
    onError: (error) => toast(error instanceof ApiError ? error.message : 'Something went wrong.', 'Error', 'error'),
  })

  if (shell.error instanceof ApiError && shell.error.status === 403) return <Forbidden />
  if (shell.error) {
    return <LoadFailed error={shell.error} onRetry={() => void shell.refetch()} what="this screen" />
  }
  if (!shell.data) return <Spinner />

  return (
    <div>
      <h4>
        <strong>Adam Intop</strong> Assign Company Actions
      </h4>
      <label className="color" style={{ marginBottom: 0 }}>
        Assign all general actions and all specific actions of this <strong>service provider</strong> to a
        company
      </label>
      <hr />
      <form
        method="post"
        onSubmit={(e) => {
          e.preventDefault()
          if (company === '') return
          /* Intrebarea din swal (`assign_company_actions.php:57-63`). Scrierea asta
             trece peste `run_only_on_companies` la TOATE actiunile
             furnizorului, si nu se poate da inapoi - in portal nu pleca fara un
             Yes, iar portarea o trimitea din prima apasare. */
          if (
            !window.confirm(
              'Are you sure?\nAll general actions and specific actions from this service provider will be assigned to this company.',
            )
          ) {
            return
          }
          assign.mutate()
        }}
      >
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="assign_to_company" className="control-label">
                Select Company <span className="required">*</span>
              </label>
              <select
                id="assign_to_company"
                className="form-control"
                name="companyId"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
              >
                <option value=""> - select - </option>
                {shell.data.companies.map((c) => (
                  <option key={c.ID} value={c.ID}>
                    {c.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="form-group mt-2 text-center center-block">
          <button type="submit" className="btn btn-primary" disabled={company === '' || assign.isPending}>
            Assign
          </button>
        </div>
      </form>
    </div>
  )
}
